import markdownToTxt from 'markdown-to-txt'

export const convertMarkdownToText = content => {
  return markdownToTxt(content)
}

export const readingTime = content => {
  const wordsPerMinute = 265
  let result
  if (content) {
    let articleContent = markdownToTxt(content)

    let textLength = articleContent.split(' ').length
    if (textLength > 0) {
      let value = Math.ceil(textLength / wordsPerMinute)
      result = `${value}m`
    }
  }
  return result
}

export const convertDate = date => {
  let d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [day, month, year].join('.')
}
